export default {
  meta: {
    title: '拓店任务报表',
    url: '/home/taskreport' // 埋点用，记录所属模块
  },
};
